import React from "react";

import { GroupedTileModelsType } from "../../../templates/ShopTileTemplate";
import { ModelSelector } from "../elements/ModelSelector";
import { BlankMattressHeader } from "./BlankMattressHeader";

import styles from "./index.module.scss";

interface ICompareTileProps {
    handleSelectProduct: (newTile: number) => void;
    selectedProducts?: number[];
    groupedDropdownModels: GroupedTileModelsType;
}

export const BlankCompareTile = (props: ICompareTileProps) => {
    const onModelSelectChange = (productId: number) => {
        props.handleSelectProduct(productId);
    };

    return (
        <div className={styles.container}>
            <div className={styles.contentContainer}>
                <div className={styles.blankCompareHeaderContainer}>
                    <BlankMattressHeader />
                </div>
                <ModelSelector
                    id="compare_tile_model_empty"
                    label="Select Model"
                    value={null}
                    onChange={onModelSelectChange}
                    groupedModels={props.groupedDropdownModels}
                    selectedProducts={props.selectedProducts}
                    placeholder="Select Model"
                />
                <div className={styles.blankCompareContentContainer}>–</div>
            </div>
        </div>
    );
};
